import axios, { AxiosRequestConfig } from 'axios'
import { url, appSettings } from 'src/provider/config/constant'
import access from 'src/utils/localAccess'
import helpers from 'src/utils/helpers'

const instance = axios.create({
    baseURL:  url.BASE_URL 
})

instance.interceptors.request.use(
    async (config: AxiosRequestConfig<any>) => {
        let token = await localStorage.getItem('authToken')
        const institutionData = localStorage.getItem('institutionData');
        const userInfo = localStorage.getItem('userInfo')
        const ibInstitutionCode = institutionData ? JSON.parse(institutionData)?.id : null;
        const profileId = userInfo ? JSON.parse(userInfo)?.profileID : null;
        
        if (token) {
            config.headers!.authToken = helpers.hashString(token)
            //@ts-ignore
            config.headers["X-Institution-Code"] = `${ibInstitutionCode}`
            //@ts-ignore
            config.headers['X-Profile-Id'] = `${profileId}`
        }
        return config;
    },

    (err) => {
        return Promise.reject(err)
    }
)

// instance.interceptors.response.use(
//     async (response) => {
       
//         return response;
//     },

//     (err) => {
//         console.log(err)
//         let message = err.response?.data?.message || ''
//         if (message === appSettings.SESSION_EXPIRATION_MSG || ['Invalid session token.', 'session has expired.'].includes(message)) access.getLogoutHandler()()
//         return Promise.reject(err)
//     }
// )

export default instance